import { Injectable } from '@angular/core';
import {GroovePlanApiService} from "../grooveplan-api.service";
import {HttpClient} from "@angular/common/http";
import {StorageService} from "../internals/storage.service";
import {Router} from "@angular/router";
import { SecureStorageService } from '../internals/secure-storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserOrganismeService extends GroovePlanApiService {

  constructor(_httpClient: HttpClient,
              storageService: StorageService,
              secureStorage: SecureStorageService,
              router: Router) {
    super(_httpClient, storageService, secureStorage, router);
    this.entityUrl = 'user-organisme'
  }
}
